export const icons = {
  none: '',
  anchor: '\uf13d',
  android: '\uf17b',
  apple: '\uf179',
  archive: '\uf187',
  'bar-chart': '\uf080',
  flask: '\uf0c3',
  'bell-o': '\uf0f3',
  briefcase: '\uf0b1',
  bug: '\uf188',
  building: '\uf0f7',
  bullseye: '\uf140',
  certificate: '\uf0a3',
  cloud: '\uf0c2',
  coffee: '\uf0f4',
  cog: '\uf013',
  cogs: '\uf085',
  'credit-card': '\uf09d',
  css3: '\uf13c',
  database: '\uf1c0',
  dashboard: '\uf0e4',
  desktop: '\uf108',
  download: '\uf01a',
  envelope: '\uf003',
  exchange: '\uf0ec',
  expand: '\uf065',
  female: '\uf182',
  'fighter-jet': '\uf0fb',
  'file-o': '\uf016',
  film: '\uf008',
  'folder-open': '\uf07c',
  globe: '\uf0ac',
  group: '\uf0c0',
  'hdd-o': '\uf0a0',
  heart: '\uf004',
  home: '\uf015',
  html5: '\uf13b',
  inbox: '\uf01c',
  key: '\uf084',
  laptop: '\uf109',
  'lightbulb-o': '\uf0eb',
  link: '\uf0c1',
  linux: '\uf17c',
  magic: '\uf0d0',
  magnet: '\uf076',
  male: '\uf183',
  'mobile-phone': '\uf10b',
  money: '\uf0d6',
  'moon-o': '\uf186',
  paperclip: '\uf0c6',
  phone: '\uf095',
  plug: '\uf1e6',
  'puzzle-piece': '\uf12e',
  road: '\uf018',
  rss: '\uf09e',
  search: '\uf002',
  server: '\uf233',
  sitemap: '\uf0e8',
  star: '\uf005',
  'sun-o': '\uf185',
  table: '\uf0ce',
  tablet: '\uf10a',
  trash: '\uf014',
  truck: '\uf0d1',
  upload: '\uf01b',
  user: '\uf007',
  windows: '\uf17a',
  wrench: '\uf0ad',
} as const;

export type FontAwesomeIconName = keyof typeof icons;

export const fontAwesomeIcons: Record<string, string> = icons;
